<div class="container p-4 p-md-5" id="finalize-payment-page">
  <div class="d-flex justify-content-end">
    <app-button id="back-desktop" [onlyIcon]="true" [isIcon]="true" [left]="true" [iconName]="'bi bi-arrow-left'"
      [buttonOptions]="backOptions" (buttonClick)="back()">
    </app-button>
  </div>
  <div class="logo-sou-mais-fc-page p-3 text-center">
    <img [src]="logoUrl" alt="Logo" />
  </div>
  <div class="finalize-payment-main-title my-4 text-center" [style.color]="labelColor">
    {{ pageTitle }}
  </div>
  <div class="row">
    <form class="col-md-8" [formGroup]="finalizePaymentformGroup">
      <div class="row">
        <div [ngClass]="{'col-lg-9': canAddJerseySize, 'col-12': !canAddJerseySize}">
          <app-select-input class="col" [id]="'planInputId'" [label]="'Plano' | replaceText"
            [options]="planOptions" formControlName="planControl" (change)="verifyPlanDiscount()">
          </app-select-input>
        </div>
        @if (canAddJerseySize) {
          <div class="col-lg-3">
            <div class="field-form-control">
              <label for="jerseySizeInputId" class="form-label" [class.required]="canAddJerseySize">
                Tamanho Camisa
              </label>
              <select class="form-select" formControlName="jerseySizeControl" id="jerseySizeInputId"
                [required]="canAddJerseySize">
                <option *ngFor="let jersey of jerseySizes" [value]="jersey.id">
                  {{ jersey.size }}
                </option>
              </select>
              <app-validation-errors *ngIf="controls.jerseySizeControl.touched"
                [errors]="controls.jerseySizeControl.errors">
              </app-validation-errors>
            </div>
          </div>
        }
        @if (canCustomizeJersey) {
          <div class="col-lg-4">
            <div class="field-form-control">
              <label for="jerseyModelInputId" class="form-label" [class.required]="canCustomizeJersey">
                Modelo Camisa
              </label>
              <select class="form-select" formControlName="jerseyModelControl" id="jerseyModelInputId"
                [required]="canCustomizeJersey">
                <option *ngFor="let model of jerseyModels" [value]="model.id">
                  {{ model.name }}
                </option>
              </select>
              <app-validation-errors *ngIf="controls.jerseyModelControl.touched"
                [errors]="controls.jerseyModelControl.errors">
              </app-validation-errors>
            </div>
          </div>
          <div class="col-lg-5">
            <div class="field-form-control">
              <label for="personalizationNameInputId" class="form-label">
                Nome na Camisa
              </label>
              <input type="text" class="form-control" formControlName="personalizationNameControl"
                id="personalizationNameInputId" maxlength="25" />
              <app-validation-errors *ngIf="controls.personalizationNameControl.touched"
                [errors]="controls.personalizationNameControl.errors">
              </app-validation-errors>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="field-form-control">
              <label for="personalizationNumberInputId" class="form-label">
                Número na Camisa
              </label>
              <input type="text" class="form-control" formControlName="personalizationNumberControl"
                id="personalizationNumberInputId" maxlength="3" onlyNumber />
              <app-validation-errors *ngIf="controls.personalizationNumberControl.touched"
                [errors]="controls.personalizationNumberControl.errors">
              </app-validation-errors>
            </div>
          </div>
        }
      </div>

      <div class="py-2"></div>
      @if (planItem) {
        <div (click)="updateValueOfPayment()">
          <app-toggle-button class="col" [id]="'frequencyInputId'" [label]="'Periodicidade'"
            [toggleButtonOptions]="frequencyOptions" [color]="'#E0C252'"
            [formControlValue]="controls.frequencyControl">
          </app-toggle-button>
        </div>

        <div class="py-2"></div>
        <div class="py-2"></div>
        @if(controls.frequencyControl.value) {
          <app-toggle-button class="col" [id]="'formOfPaymentInputId'" [label]="'Forma de Pagamento'"
            [toggleButtonOptions]="formOfPaymentOptions" [color]="'#FFFFFF'"
            [formControlValue]="controls.formOfPaymentControl" (change)="applyPlanDiscount()">
          </app-toggle-button>
        }
        @if (showDependentsOptions && planItem[0].amount != 0) {
          <div class="py-2"></div>
          <div class="row">
            <div [ngClass]="{'col-lg-8': dependentCustomization, 'col': !dependentCustomization}">
              <app-select-input class="col"
                [id]="'dependentInputId'"
                [label]="'Dependentes'"
                [options]="dependentsOptions"
                formControlName="dependentControl">
              </app-select-input>
            </div>
            @if (dependentCustomization) {
              <app-button class="col-lg-4 d-flex align-items-center"
                [disabled]="
                  !finalizePaymentformGroup.get('dependentControl')?.value ||
                  finalizePaymentformGroup.get('dependentControl')?.value === '0'
                "
                [buttonOptions]="buttonAddDependentsOptions"
                (buttonClick)="updateValueWithDependents(true)">
              </app-button>
            }
          </div>
        }
        <div *ngIf="showCreditCardOptions" class="payment-additional-info mt-4 fs-small">
          <form [formGroup]="creditCardformGroup">
            <div class="row">
              <app-input-custom class="col-12 col-md-6" [id]="'cardNumberInputId'"
                [placeholder]="'Insira o número do cartão'" [label]="'Número do cartão'"
                [mask]="InputMaskTypesEnum.CREDIT_CARD" formControlName="cardNumberControl"></app-input-custom>
              <app-input-custom class="col-md-6" [id]="'expirationDateInputId'" [placeholder]="'MM/AA'"
                [label]="'Data de validade'" [mask]="InputMaskTypesEnum.MES_ANO" [dropSpecialCharacters]="false"
                formControlName="expirationDateControl"></app-input-custom>
            </div>
            <div class="row">
              <app-input class="col-md-6" [id]="'cvvInputId'" [label]="'CVV'" [placeholder]="'CVV'"
                [type]="InputTypeEnum.NUMBER" [maxLength]="3" [minLength]="3" formControlName="cvvControl"></app-input>
              @if (numberOfInstallmentsOptions.length > 0) {
                <app-select-input class="col-md-6" [id]="'numberOfInstallmentsInputId'" [label]="'Nº de parcelas'"
                  [options]="numberOfInstallmentsOptions" formControlName="numberOfInstallmentsControl"
                  (change)="updateValueWithInstallments()">
                </app-select-input>
              }
            </div>
            <div class="row">
              <app-input class="col" [id]="'cardNameInputId'" [label]="'Nome do cartão'" [isUpperCase]="true"
                [placeholder]="'Insira o nome do titular do cartão'" formControlName="cardNameControl"></app-input>
            </div>
            <div class="row">
              <app-input-custom class="col" [id]="'CPFInputId'" [label]="'CPF'" [mask]="InputMaskTypesEnum.CPF"
                [placeholder]="'Insira o CPF do titular'" formControlName="CPFControl"></app-input-custom>
            </div>
            @if (showCanUseCardControl) {
              <div class="row my-3">
                <app-checkbox class="col" [id]="'canUseCardId'" [label]="
                    'Utilizar esse cartão de forma recorrente nas próximas faturas'
                  " formControlName="canUseCardControl">
                </app-checkbox>
              </div>
            }
          </form>
        </div>
        <ng-container *ngIf="showInstallments">
          <div class="row">
            <app-select-input class="col-12" [id]="'installments'" [label]="'Nº de parcelas'"
              [options]="numberOfInstallmentsOptions" formControlName="installments"
              (change)="updateValueWithInstallments()">
            </app-select-input>
          </div>
        </ng-container>
        <ng-container *ngIf="showDueDay">
          <div class="row">
            <app-select-input class="col-12" [id]="'dueDay'" [label]="'Dia de Vencimento'"
              [options]="dueDayOptions" formControlName="dueDayControl">
            </app-select-input>
          </div>
        </ng-container>
      }
    </form>
    @if (paymentSummary?.planName) {
    <div class="col-md-4 summary-payment">
      <ng-container *ngIf="memberCoupons.length > 0; else elseMemberCoupons">
        <button class="btn button-coupon-select d-flex justify-content-between align-items-center" (click)="openCouponModal()">
          <span>{{ placeholderCoupon }}</span>
          <i class="bi bi-arrow-right"></i>
        </button>
        <app-validation-errors *ngIf="couponMessage.length > 0"
          [customSingleErrorMessage]="couponMessage">
        </app-validation-errors>
      </ng-container>
      <ng-template #elseMemberCoupons>
        <form [formGroup]="couponFormGroup">
          <div class="row">
            <app-input class="col-lg-8" [id]="'coupon'" [label]="'Cupom'" [type]="InputTypeEnum.COUPON"
              [placeholder]="'Insira o cupom de desconto'" [errorMessage]="couponMessage" formControlName="coupon"
              (input)="transformCouponToUppercase()">
            </app-input>
            <app-button class="col-lg-4 d-flex align-items-center" [buttonOptions]="couponOptions"
              (buttonClick)="onApplyCoupon()" [disabled]="couponFormGroup.controls.coupon.value?.length <= 0">
            </app-button>
          </div>
        </form>
      </ng-template>
      <div class="my-4">Resumo</div>
      <div class="row my-3">
        <div class="col-7 fs-small">
          {{ paymentSummary.planName }} -
          {{ getFrequencyFormLabel(controls.frequencyControl.value || "") }}
        </div>
        <div class="col-5">
          <div class="fs-small fw-medium d-flex justify-content-end">
            {{
            paymentSummary.amount > 0
            ? (paymentSummary.amount | customCurrency)
            : "Gratuito"
            }}
          </div>
        </div>
      </div>

      <hr class="my-3" />

      <div class="row mb-3" *ngIf="paymentSummary.discount > 0">
        <div class="col-7 fs-small">DESCONTO</div>
        <div class="col-5">
          <div class="fs-small fw-medium d-flex justify-content-end">
            {{ paymentSummary.discount | customCurrency }}
          </div>
        </div>
      </div>
      <div class="row mb-3" *ngIf="paymentSummary.couponDiscount > 0">
        <div class="col-7 fs-small">DESCONTO CUPOM</div>
        <div class="col-5">
          <div class="fs-small fw-medium d-flex justify-content-end">
            {{ paymentSummary.couponDiscount | customCurrency }}
          </div>
        </div>
      </div>
      <div class="row mb-3" *ngIf="paymentSummary.recurrenceAmount > 0">
        <div class="col-7 fs-small">TOTAL RECORRENCIA MENSAL</div>
        <div class="col-5">
          <div class="fs-small fw-medium d-flex justify-content-end">
            {{ paymentSummary.recurrenceAmount | customCurrency }}
          </div>
        </div>
      </div>
      <div class="row mb-3" *ngIf="operation === 1 || operation === 6">
        <div class="col-7 fs-small">TOTAL UPGRADE</div>
        <div class="col-5">
          <div class="fs-small fw-medium d-flex justify-content-end">
            {{ getUpgradeTotal() | customCurrency }}
          </div>
        </div>
      </div>
      <div class="row mb-3" *ngIf="dependentCustomization && totalDependentsValue > 0">
        <div class="col-7 fs-small">DEPENDENTES ({{ dependentsToContract.length }})</div>
        <div class="col-5">
          <div class="fs-small fw-medium d-flex justify-content-end">
            {{ totalDependentsValue | customCurrency }}
          </div>
        </div>
      </div>
      <div class="row mb-3" *ngIf="subscriptionFee > 0">
        <div class="col-7 fs-small">TAXA DE ADESÃO</div>
        <div class="col-5">
          <div class="fs-small fw-medium d-flex justify-content-end">
            {{ subscriptionFee | customCurrency }}
          </div>
        </div>
      </div>
      <div class="row mb-3" *ngIf="operation !== 1 && operation !== 6">
        <div class="col-7 fs-small">TOTAL</div>
        <div class="col-5">
          <div class="fs-small fw-medium d-flex justify-content-end">
            {{ getTotalAmount() | customCurrency }}
          </div>
        </div>
      </div>


      @if (paymentSummary.enableItems?.length > 0){
        <app-card-plan-items [planItem]="paymentSummary"> </app-card-plan-items>
      }

      <div class="mt-4 row">
        <app-button class="col w-100"
          [disabled]="
            finalizePaymentformGroup.invalid ||
            creditCardformGroup.invalid ||
            submitCount > 0
          "
          [buttonOptions]="buttonOptions"
          (buttonClick)="save()">
        </app-button>
        @if(submitCount > 0){
          <p class="pt-2 small text-center">
            Novo envio em {{ submitCount }} segundo(s)
          </p>
        }
      </div>
    </div>
    }
  </div>
</div>

<app-payment-modal
  [modalId]="modalId"
  [paymentType]="paymentType"
  [paymentModalData]="paymentModalData"
  (confirmActionChange)="onModalConfirm()">
</app-payment-modal>

<app-modal-select-coupon
  [modalId]="couponModalId"
  [couponOptions]="couponOptions"
  [couponFormGroup]="couponFormGroup"
  [memberCoupons]="memberCoupons"
  (confirmAction)="onCouponSelect($event)">
</app-modal-select-coupon>

<app-dependentes-modal
  [modalId]="'dependentes-modal'"
  [qtyDependents]="dependentsAmount"
  [initialDependents]="dependentsToContract"
  [relationshipDegrees]="relationshipDegrees"
  [planPaymentId]="paymentSummary?.id"
  [operationType]="getOperationType(operation)"
  (dependentsUpdated)="onDependentsUpdated($event)">
</app-dependentes-modal>
